export const contactsData = {
    email: 'psvishnu131@gmail.com',
    phone: '+91 9037144873',
    address: 'Vatakara,Calicut,Kerala',

    sheetAPI: ''
}